export default class ParentsAPI {
  private services: any;

  constructor(services) {
    this.services = services;
  }

  public getCoursesSummary({ parentID }) {
    return this.services.baseAPI.get(
      `/parents/courses?parentid=${parentID}`,
      false
    );
  }

  public getChildren(parentID) {
    return this.services.baseAPI.get(`/parents/${parentID}/children`, false);
  }

  public getCourseDetails({ parentID, courseID }) {
    return this.services.baseAPI.get(
      `/parents/course/details?parentid=${parentID}&courseid=${courseID}`,
      false
    );
  }

  public makePayment(item) {
    return this.services.baseAPI.post(
      `/payment/parents/setup-subscription`,
      item,
      false
    );
  }

  public addChildLegacy(item) {
    return this.services.baseAPI.post(`parents/subscription/add_learner`, item);
  }
  public addChild(item) {
    return this.services.baseAPI.post(`/parents/student/registration`, item);
  }

  public switchSubscriptionPackage(item) {
    return this.services.baseAPI.post(`users/parents/switch_package`, item);
  }
  public cancelSubscription() {
    return this.services.baseAPI.post(`users/parents/cancel_subscription`);
  }

  public registerMarketingParents(item) {
    return this.services.baseAPI.post(
      `users/registration/marketing_parents`,
      item,
      true
    );
  }

  public registerParent_v3(data) {
    return this.services.baseAPI.post(
      `/users/registration/parents`,
      data,
      true
    );
  }
  public getPaymentHistory() {
    return this.services.baseAPI.get(`/parents/billing-history`, false);
  }
}



// WEBPACK FOOTER //
// ./src/services/API/v1/Parents.ts